import TallyAction from "createProposal/action/TallyAction"
import type { TallyActionArgs } from "createProposal/action/types"
import { ExecutableCallType } from "query/graphql"

class EmptyAction extends TallyAction {
  constructor(args?: TallyActionArgs) {
    super(args)

    this.recipe = ExecutableCallType.Empty
    this.value = "0"
  }
}

export default EmptyAction
